import React from 'react'
import PropTypes from 'prop-types'

import { usePagination } from '../../lib/pagination'

export const Pagination = ({ currentPage, totalCount, siblingCount, pageSize, onPageChange }) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  return (
    <ul className="trtui-pagination trtui-pagination-separated trtui-justify-content-center trtui-justify-content-sm-end trtui-mb-sm-0">
      <li
        className={`trtui-page-item ${
          currentPage === 1 ? 'trtui-disabled' : 'trtui-cursor-pointer'
        }`}
        data-testid="OnPreviousLink"
        onClick={() => currentPage > 1 && onPrevious()}
      >
        <span className="trtui-page-link">
          <i className="ri-arrow-left-s-line" />
        </span>
      </li>
      {paginationRange.map((pageNumber, pageNumberIndex) => {
        return (
          <li
            key={pageNumberIndex}
            className={`trtui-page-item ${
              pageNumber === currentPage ? 'trtui-active' : 'trtui-cursor-pointer'
            }`}
            data-testid="OnActiveLink"
            onClick={() => pageNumber !== '...' && onPageChange(pageNumber)}
          >
            <span aria-label="1" className="trtui-page-link">
              {pageNumber}
            </span>
          </li>
        )
      })}
      <li
        className={`trtui-page-item ${
          currentPage === totalCount ? 'trtui-disabled' : 'trtui-cursor-pointer'
        }`}
        data-testid="OnNextLink"
        onClick={() => currentPage < totalCount && onNext()}
      >
        <span className="trtui-page-link">
          <i className="ri-arrow-right-s-line" />
        </span>
      </li>
    </ul>
  )
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalCount: PropTypes.number,
  siblingCount: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
}
